<template>
  <div class="auth-container account-active-container">
    <img class="logo mb-4" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <h5 class="d-flex flex-column mb-4">
      <span>{{ $t('auth.account_active_heading_1') }}</span>
      <span>{{ $t('auth.account_active_heading_2') }}</span>
    </h5>
    <strong class="paragraph-title mt-4">1. {{ $t('auth.account_active_step_1_heading') }}</strong>
    <p class="paragraph-content">{{ $t('auth.account_active_step_1_description') }}</p>
    <strong class="paragraph-title">2. {{ $t('auth.account_active_step_2_heading') }}</strong>
    <p class="paragraph-content">{{ $t('auth.account_active_step_2_description') }}</p>
    <strong class="paragraph-title">3. {{ $t('auth.account_active_step_3_heading') }}</strong>
    <p class="paragraph-content">{{ $t('auth.account_active_step_3_description') }}</p>
    <strong class="paragraph-title">4. {{ $t('auth.account_active_step_4_heading') }}</strong>
    <p class="paragraph-content">{{ $t('auth.account_active_step_4_description') }}</p>
    <router-link :to="{ name: 'projects'}" class="mt-4">
      <button type="submit" class="btn btn-medium btn-orange-dark">{{ $t('global.projects') }}</button>
    </router-link>
    <p class="paragraph-content mt-4">{{ $t('auth.account_active_footer') }}</p>
  </div>
</template>

<script>
export default {
  name: 'AccountActive',

  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) this.$router.push({ name: 'projects' })
    })
  }
}
</script>
